/**
 * TeacherLayout - Shared layout for teacher pages
 * Includes header, navigation, and footer
 */

import { Outlet, Link, useLocation } from 'react-router-dom';

interface TeacherLayoutProps {
  signOut?: () => void;
  user?: any;
}

export function TeacherLayout({ signOut, user }: TeacherLayoutProps) {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <div className="min-h-screen flex bg-gradient-to-br from-[#E2E5EC] via-white to-[#CED4DE]">
      <aside className="w-52 shrink-0 border-r border-[#CED4DE] bg-white/95 backdrop-blur-sm px-3 py-4 flex flex-col sticky top-0 h-screen">
        <Link to="/login/teacher" className="mb-5 flex justify-center">
          <img
            src="/icons/centauri-logo.png"
            alt="Centauri"
            className="h-14 hover:opacity-80 transition-opacity"
          />
        </Link>

        <nav className="flex flex-col gap-2">
          <Link
            to="/login/teacher"
            className={`px-3 py-2 rounded-lg font-medium transition-all ${
              isActive('/login/teacher') && location.pathname === '/login/teacher'
                ? 'bg-[#12356B] text-white'
                : 'text-slate-700 hover:bg-[#E2E5EC]'
            }`}
          >
            Dashboard
          </Link>
          <Link
            to="/login/teacher/sessions"
            className={`px-3 py-2 rounded-lg font-medium transition-all ${
              isActive('/login/teacher/sessions')
                ? 'bg-[#12356B] text-white'
                : 'text-slate-700 hover:bg-[#E2E5EC]'
            }`}
          >
            Sessions
          </Link>
          <Link
            to="/login/teacher/guide"
            className={`px-3 py-2 rounded-lg font-medium transition-all ${
              isActive('/login/teacher/guide')
                ? 'bg-[#12356B] text-white'
                : 'text-slate-700 hover:bg-[#E2E5EC]'
            }`}
          >
            Game Guide
          </Link>
          <Link
            to="/login/teacher/profile"
            className={`px-3 py-2 rounded-lg font-medium transition-all ${
              isActive('/login/teacher/profile')
                ? 'bg-[#12356B] text-white'
                : 'text-slate-700 hover:bg-[#E2E5EC]'
            }`}
          >
            Settings
          </Link>
        </nav>

        <div className="mt-auto pt-4 border-t border-[#CED4DE]">
          <div className="text-sm text-slate-600 mb-3 truncate">
            {user?.signInDetails?.loginId || 'Teacher'}
          </div>
          {signOut && (
            <button
              onClick={signOut}
              className="w-full px-4 py-2 text-sm font-medium text-white bg-[#DD6832] hover:bg-[#c4562a] rounded-lg transition-colors"
            >
              Sign Out
            </button>
          )}
        </div>
      </aside>

      <main className="flex-1 min-w-0 px-4 sm:px-6 lg:px-8 py-6">
        <Outlet />
      </main>
    </div>
  );
}
